import { cva } from 'class-variance-authority';

export const containerVariants = cva('', {
  variants: {
    variant: {
      list: 'w-[27.5rem] min-h-[3.25rem]',
      default: '',
      step: 'w-[27.5rem] min-h-[3.25rem]',
      status: 'w-[20rem] gap-2xl',
    },
    size: {
      sm: '',
      md: '',
    },
  },
  compoundVariants: [
    {
      variant: 'default',
      size: 'sm',
      className: 'w-[14.25rem] gap-lg',
    },
    {
      variant: 'default',
      size: 'md',
      className: 'w-[23.75rem] gap-2xl',
    },
  ],
});

export const titleVariants = cva('w-full', {
  variants: {
    variant: {
      list: 'text-md',
      default: '',
      step: 'text-md',
      status: 'text-sm',
    },
    size: {
      sm: 'text-sm',
      md: 'text-md',
    },
  },
});

export const descriptionVariants = cva('w-full', {
  variants: {
    variant: {
      default: '',
    },
    size: {
      sm: 'text-xs',
      md: 'text-sm',
    },
  },
  compoundVariants: [
    {
      variant: 'default',
      size: 'sm',
      className: 'mt-1',
    },
  ],
});
